import React from 'react';
import Button from '../../../../../components/Button';
import FixedBottomNavBar from '../../../../../components/FixedBottomNavBar';
import './CsReviewCreateNavbar.scss';

const CsReviewCreateNavbar = (): JSX.Element => {
  return (
    <FixedBottomNavBar className="cs-review-create-navbar">
      <div className="button-group">
        <Button color="primary" text="등록하기" type="submit" form="create-review-form" />
      </div>
    </FixedBottomNavBar>
  );
};

export default CsReviewCreateNavbar;
